import { render, staticRenderFns } from "./MicrophonePreview.vue?vue&type=template&id=8ba67462"
import script from "./MicrophonePreview.vue?vue&type=script&lang=js"
export * from "./MicrophonePreview.vue?vue&type=script&lang=js"
import style0 from "./MicrophonePreview.vue?vue&type=style&index=0&id=8ba67462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports